import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import currentDevice from '../../common/_media';
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind()

const heroSlider = document.querySelector('.hero__slider');
if (heroSlider !== null) {
    new Swiper(heroSlider, {
        modules: [Navigation],
        slidesPerView: 1,
        navigation: {
            nextEl: '.hero__navigation--next',
            prevEl: '.hero__navigation--prev'
        }
    })
}

const heroVideo = document.querySelector('.hero__video');

if (heroVideo !== null) {
    heroVideo.muted = true;
    let source = '';

    switch(currentDevice()) {
        case 'desktop':
            source = heroVideo.getAttribute('data-video-desktop');
            break;
        case 'tablet':
            source = heroVideo.getAttribute('data-video-tablet');
            break;
        case 'mobile':
            source = heroVideo.getAttribute('data-video-mobile');
            break;
        default: 
            source = heroVideo.getAttribute('data-video-desktop');
            break;
    }
    console.log(currentDevice());

    heroVideo.insertAdjacentHTML('afterbegin', `<source src='${source}'>`);
    
}
